import { app } from '../../../../../app';
import { Controller } from './delete-accounts.controller';

app.component('companyUserDirectoriesManageUserDeleteAccounts', {
    bindings: {
        accountsForCompanyUser: '<',
        companyId: '<',
        selectedAccounts: '<',
    },
    controller: Controller,
    templateUrl: require('./delete-accounts.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/delete-accounts/delete-accounts.component.js